"use client";

import React from "react";

import Alert from "@/components/design-system/alert";

import previousPurchaseStyle from "./previousPurchaseBlock.module.scss";

interface PreviousPurchaseBlockProps {
  lastPurchaseDate: string;
  onClick: () => void;
  useCompactDisplay?: boolean;
  className?: string;
  isTopsortClickable?: boolean;
}

export function PreviousPurchaseBlock({
  lastPurchaseDate,
  onClick,
  useCompactDisplay,
  className = "",
  isTopsortClickable = false,
}: PreviousPurchaseBlockProps) {
  if (!lastPurchaseDate) {
    return null;
  }

  if (useCompactDisplay) {
    return (
      <button
        type="button"
        className={`${previousPurchaseStyle.productPurchaseHistoryLink} ${className}`}
        onClick={onClick}
      >
        Purchased on {lastPurchaseDate}
      </button>
    );
  }

  const alertClassName = `${previousPurchaseStyle.pdpAlert} ${className}`.trim();

  const alert = (
    <Alert
      variant="neutral"
      size="xs"
      title={`You purchased this item on ${lastPurchaseDate}`}
      action={{ label: "Purchase History", onClick }}
      className={isTopsortClickable ? className : alertClassName}
    />
  );

  return isTopsortClickable ? (
    <div data-ts-clickable className={previousPurchaseStyle.pdpAlert}>
      {alert}
    </div>
  ) : (
    alert
  );
}
